'use-strict'; /* eslint-disable no-console, no-unused-vars */

/**
 * infiniteScroll lazy loads the next 24 cards
 * when scrolling past the first 24.
 * Only initializes on Content Listing pages.
 */

import _ from 'lodash';
const Blazy = require('blazy');
const bLazy = new Blazy();

const infiniteScroll = (function() {

  const hiddenClass = 'is-hidden';
  const visibleClass = 'is-visible';
  let cards = document.querySelectorAll(`.card__item.${hiddenClass}`);
  const listSize = cards.length;
  let hiddenCards;

  /**
	 * showCards
	 *
	 * Removes hidden class and adds visible classes
	 * to reveal cards that should be shown on page
	 *
	 * @param cardList: array of card elements to reveal on page
	 */
  function showCards(cardList) {
    cardList.forEach(card => {
      if (card.classList.contains(hiddenClass)) {
        card.classList.remove(hiddenClass);
        card.classList.add(visibleClass);
      }
    });
    bLazy.revalidate();
  }

  /**
	 * scrollHandler
	 *
	 * Called when scroll direction is down.
   * Lazy loads next set of cards
	 */
  function scrollHandler() {
    cards = document.querySelectorAll(`.card__item.${hiddenClass}`);
    if (cards.length < 1) {
      return;
    }
    hiddenCards = Array.from(cards).slice(0, 24);
    showCards(hiddenCards);
  }

  /**
	 * scrollDirection
	 *
	 * Called during scroll event to
	 * determine scroll direction and lazy load cards
	 */
  function scrollDirection() {
    let prevScrollPos = 0;
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop; // credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"

    if (scrollTop > (prevScrollPos - 100)) {
      // when scroll direction is down
      const lastCardIndex = document.querySelectorAll(`.card__item.${visibleClass}`).length - 1;
      const lastCard = document.querySelectorAll(`.card__item.${visibleClass}`)[lastCardIndex];
      let lastCardOffset = lastCard.offsetTop + lastCard.offsetHeight;
      let pageOffset = scrollTop + window.innerHeight;
      // load the next set of cards
      if (pageOffset > lastCardOffset) scrollHandler();
    } else {
      return;
    }

    prevScrollPos = scrollTop <= 0 ? 0 : scrollTop; // for mobile or negative scrolling
  }

  function init() {
    if (listSize <= 24) {
      showCards(cards);
    } else if (listSize > 24) {
      const initialCards = Array.from(cards).slice(0, 24);
      showCards(initialCards);
    }

    window.addEventListener('scroll', _.debounce(() => scrollDirection(), 50));
  }


  return {
    init,
  }
})();

export default infiniteScroll;



// WEBPACK FOOTER //
// ./resources/assets/js/infinite-scroll.js